import React from 'react'
import { getCountUnities, getMinAndMaxPrice } from '@helpers/helper.unities'
import { getLocation, getStatus, getContructionDate } from '@helpers/helper.developments'
import useQueryUnities from '@hooks/useQueryUnities'
import useQueryDevelopment from '@hooks/useQueryDevelopment'
import { RealEstateDataPageComponentData } from 'types'
import Image from '@components/Image'

interface ExternalProps {
  developmentID: string
}

type CombinedProps = RealEstateDataPageComponentData & ExternalProps

const AboutDevelopment_2 = ({
  developmentID,
  darkMode,
  amenitiesBarDev,
  global_data,
  image_gatsby,
}: CombinedProps) => {
  const { data: allDevelopmentData } = useQueryDevelopment(
    developmentID,
    global_data.pageConfig.keys.tokko,
  )
  const {
    allUnitiesData,
    isLoading: isLoadingUnities,
    isError: isErrorUnities,
  } = useQueryUnities(developmentID, global_data.pageConfig.keys.tokko)

  return (
    <section className={'about-top b amenities ' + (darkMode ? 'dark-mode' : '')}>
      <div className="container-fluid px-lg-5">
        <div className="d-flex flex-column flex-lg-row flex-wrap justify-content-lg-around justify-content-center align-items-center gap-4">
          {/* Image */}
          <div className="column col-6 col-lg-auto d-lg-block d-none align-self-end">
            <Image
              className="no-border image-dev"
              objectFit="cover"
              alt="image-dev"
              image={image_gatsby!}
            />
          </div>
          {/* Prices */}
          <div className="column min-180px max-15vw pb-4 py-4 py-lg-4 col-6 col-lg-auto d-lg-block d-flex order-2 flex-fill">
            <div className="d-flex flex-column w-100 item mb-lg-4">
              <p className="mb-3 pb-2 text-center text-lg-start text-uppercase">Desde</p>
              <h4 className="text-center text-lg-start ">
                {isLoadingUnities || isErrorUnities
                  ? 'Cargando..'
                  : 'USD ' +
                    Intl.NumberFormat('de-DE').format(getMinAndMaxPrice(allUnitiesData).min)}
              </h4>
            </div>
            <div className="d-flex flex-column w-100 item">
              <p className="mb-3 pb-2 text-center text-lg-start text-uppercase">Hasta</p>
              <h4 className="text-center text-lg-start ">
                {isLoadingUnities || isErrorUnities
                  ? 'Cargando..'
                  : 'USD ' +
                    Intl.NumberFormat('de-DE').format(getMinAndMaxPrice(allUnitiesData).max)}
              </h4>
            </div>
          </div>
          {/* State & Unities */}
          <div className="column min-180px max-15vw pb-4 py-4 py-lg-4 col-6 col-lg-auto d-lg-block d-flex order-3 flex-fill">
            {amenitiesBarDev?.state && (
              <div
                className={
                  'd-flex flex-column w-100 info text-center text-lg-start ' +
                  (amenitiesBarDev?.unities ? 'mb-lg-4' : '')
                }
              >
                <p className="mb-3 pb-2 text-uppercase">{amenitiesBarDev?.state}</p>
                <h4 className="text-uppercase ">{getStatus(allDevelopmentData)}</h4>
              </div>
            )}
            {amenitiesBarDev?.unities && (
              <div className="d-flex flex-column w-100 info text-center text-lg-start">
                <p className="mb-3 pb-2 text-uppercase">{amenitiesBarDev?.unities}</p>
                <h4 className="text-uppercase ">
                  {isLoadingUnities || isErrorUnities
                    ? ''
                    : getCountUnities(allUnitiesData,!global_data.pageConfig.keys.tokko) || 'Sin especificar'}
                </h4>
              </div>
            )}
          </div>
          {/* Location & Date */}
          <div className="column min-180px max-15vw py-4 py-lg-4 col-6 col-lg-auto d-lg-block d-flex order-4 flex-fill">
            {amenitiesBarDev?.location && (
              <div
                className={
                  'd-flex flex-column w-100 info text-center text-lg-start ' +
                  (amenitiesBarDev?.delivery ? 'mb-lg-4' : '')
                }
              >
                <p className="mb-3 pb-2 text-uppercase">{amenitiesBarDev?.location}</p>
                <h4 className="text-uppercase ">{getLocation(allDevelopmentData, true)[0]}</h4>
              </div>
            )}
            {amenitiesBarDev?.delivery && (
              <div className="d-flex flex-column w-100 info text-center text-lg-start">
                <p className="mb-3 pb-2 text-uppercase">{amenitiesBarDev?.delivery}</p>
                <h4 className="text-uppercase ">
                  {getContructionDate(allDevelopmentData) || 'Sin especificar'}
                </h4>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default AboutDevelopment_2
